export const endpoints = {
  login: "/user/login",
  register: "/user/register",
  signup: "/user/register",
  get_profile: '/user/me',
};
